<script setup lang="ts">
import NewAirRoadSeparator from '@/components/separators/NewAirRoadSeparator.vue';
</script>

<template>
  <header
    :class="$style.h3LineNewAirRoadHeader"
    data-testid="h3LineNewAirRoadHeader"
  >
    <h3 :class="$style.h3">
      <slot></slot>
    </h3>
    <NewAirRoadSeparator :class="$style.hr" />
  </header>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.h3LineNewAirRoadHeader {
}
  .h3 {
    margin-bottom: 0;
  }
  .hr {
    margin: 0.5em 0; /* half of `h3` default margin */
  }
</style>
